import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/token-icon/repositories/pancakeswap.repository.ts
import { ChainId } from "@one-inch-community/models";
import { getAddress } from "viem/utils";
var chainName = {
  [ChainId.eth]: "eth",
  [ChainId.bnb]: "",
  [ChainId.matic]: "",
  [ChainId.op]: "",
  [ChainId.arbitrum]: "",
  [ChainId.gnosis]: "",
  [ChainId.avalanche]: "",
  [ChainId.fantom]: "",
  [ChainId.aurora]: "",
  [ChainId.klaytn]: "",
  [ChainId.zkSyncEra]: ""
};
var pancakeSwapRepository = ({ address, chainId }) => {
  return new Promise((resolve, reject) => {
    if (!address || !chainId || chainName[chainId] === "") return reject();
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = `https://tokens.pancakeswap.finance/images/${chainName[chainId]}/${getAddress(address.toLowerCase())}.png`;
  });
};
export {
  pancakeSwapRepository
};
//# sourceMappingURL=pancakeswap.repository-LI7PUPCX.js.map
